import React, { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { useIntersection } from '../contexts/IntersectionObserver';


// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const ServiceSteps = () => {
  // 
  // ─── REF TO HANDLE ANIMATE ON WINDOW APPEAR ───────────────────────────────────────
  //
  const stepsRef = useRef();
  useIntersection({ element: stepsRef }, () => { });

  // 
  // ─── STEPS CONTENT ───────────────────────────────────────
  //
  let steps = [
    {
      number: '01',
      label: 'Discussion',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M2 3V16C2 16.55 2.45 17 3 17H6V22L12 17H21C21.55 17 22 16.55 22 16V3C22 2.45 21.55 2 21 2H3C2.45 2 2 2.45 2 3Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M2 3V16C2 16.55 2.45 17 3 17H6V22L12 17H21C21.55 17 22 16.55 22 16V3C22 2.45 21.55 2 21 2H3C2.45 2 2 2.45 2 3Z"></path>
      </svg>
    },
    {
      number: '02',
      label: 'Proposition',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" d="M12 8V12"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" d="M6 16V12H18V16"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="0" stroke="#1c1a1a" fill="#ffcb55" d="M16 2H8V8H16V2Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M16 2H8V8H16V2Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M22 16H14V22H22V16Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M22 16H14V22H22V16Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M10 16H2V22H10V16Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M10 16H2V22H10V16Z"></path>
      </svg>
    },
    {
      number: '03',
      label: 'Développement',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path fill="#ffb100" d="M15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L16.7071 18.7071C16.3166 19.0976 15.6834 19.0976 15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929L20.5858 12L15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289Z" clipRule="evenodd" fillRule="evenodd" undefined="0" transform="translate(2,2)"></path><path fill="#1c1a1a" d="M15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L16.7071 18.7071C16.3166 19.0976 15.6834 19.0976 15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929L20.5858 12L15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289Z" clipRule="evenodd" fillRule="evenodd" undefined="1"></path>
        <path fill="#ffb100" d="M8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L3.41421 12L8.70711 17.2929C9.09763 17.6834 9.09763 18.3166 8.70711 18.7071C8.31658 19.0976 7.68342 19.0976 7.29289 18.7071L1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289Z" clipRule="evenodd" fillRule="evenodd" undefined="0" transform="translate(2,2)"></path><path fill="#1c1a1a" d="M8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L3.41421 12L8.70711 17.2929C9.09763 17.6834 9.09763 18.3166 8.70711 18.7071C8.31658 19.0976 7.68342 19.0976 7.29289 18.7071L1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289Z" clipRule="evenodd" fillRule="evenodd" undefined="1"></path>
      </svg>
    },
    {
      number: '04',
      label: 'Présentation',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M3 20H21C21.55 20 22 19.55 22 19V4C22 3.45 21.55 3 21 3H3C2.45 3 2 3.45 2 4V19C2 19.55 2.45 20 3 20Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M3 20H21C21.55 20 22 19.55 22 19V4C22 3.45 21.55 3 21 3H3C2.45 3 2 3.45 2 4V19C2 19.55 2.45 20 3 20Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M2 8H22V4C22 3.45 21.55 3 21 3H3C2.45 3 2 3.45 2 4V8Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M2 8H22V4C22 3.45 21.55 3 21 3H3C2.45 3 2 3.45 2 4V8Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" d="M5 5.5H5.01"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" d="M7.99 5.5H8"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="1" stroke="#1c1a1a" d="M10.99 5.5H11"></path>
      </svg>
    },
    {
      number: '05',
      label: 'Mise en ligne',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" d="M2.46 15C2.16 14.05 2 13.05 2 12C2 10.95 2.16 9.95 2.46 9H21.54C21.84 9.95 22 10.95 22 12C22 13.05 21.84 14.05 21.54 15H2.46Z"></path>
      </svg>
    },
    {
      number: '06',
      label: 'Maintenance',
      icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-reactroot="">
        <path fill="#ffb100" d="M13.87 4.89L13.56 2.44C13.53 2.19 13.32 2 13.06 2H9.95C9.7 2 9.48 2.19 9.45 2.44L9.18 4.59C9.16 4.77 9.03 4.93 8.86 4.99C8.02 5.3 7.22 5.78 6.53 6.4L4.25 5.44C4.02 5.34 3.75 5.43 3.62 5.65L2.06 8.35C1.94 8.57 2 8.85 2.2 9L4.17 10.49C3.96 11.5 3.96 12.53 4.16 13.51H4.17L2.2 15C2 15.15 1.94 15.43 2.07 15.65L3.63 18.35C3.76 18.57 4.03 18.66 4.26 18.56L6.54 17.6L6.53 17.61C6.9 17.94 7.32 18.24 7.77 18.5C8.22 18.76 8.68 18.97 9.16 19.13V19.11L9.47 21.56C9.48 21.81 9.7 22 9.95 22H13.07C13.32 22 13.53 21.81 13.57 21.56L13.84 19.41C13.86 19.23 13.99 19.07 14.16 19.01C15 18.7 15.8 18.22 16.49 17.6L18.77 18.56C19 18.66 19.27 18.57 19.4 18.35L20.96 15.65C21.09 15.43 21.03 15.15 20.83 15L18.86 13.51C19.07 12.5 19.07 11.47 18.87 10.49H18.86L20.81 9C21.01 8.85 21.07 8.57 20.94 8.35L19.38 5.65C19.25 5.43 18.98 5.34 18.75 5.44L16.48 6.4L16.49 6.39C16.12 6.06 15.7 5.76 15.25 5.5C14.8 5.24 14.34 5.03 13.86 4.87" clipRule="evenodd" fillRule="evenodd" undefined="0" transform="translate(2,2)"></path><path fill="none" d="M13.87 4.89L13.56 2.44C13.53 2.19 13.32 2 13.06 2H9.95C9.7 2 9.48 2.19 9.45 2.44L9.18 4.59C9.16 4.77 9.03 4.93 8.86 4.99C8.02 5.3 7.22 5.78 6.53 6.4L4.25 5.44C4.02 5.34 3.75 5.43 3.62 5.65L2.06 8.35C1.94 8.57 2 8.85 2.2 9L4.17 10.49C3.96 11.5 3.96 12.53 4.16 13.51H4.17L2.2 15C2 15.15 1.94 15.43 2.07 15.65L3.63 18.35C3.76 18.57 4.03 18.66 4.26 18.56L6.54 17.6L6.53 17.61C6.9 17.94 7.32 18.24 7.77 18.5C8.22 18.76 8.68 18.97 9.16 19.13V19.11L9.47 21.56C9.48 21.81 9.7 22 9.95 22H13.07C13.32 22 13.53 21.81 13.57 21.56L13.84 19.41C13.86 19.23 13.99 19.07 14.16 19.01C15 18.7 15.8 18.22 16.49 17.6L18.77 18.56C19 18.66 19.27 18.57 19.4 18.35L20.96 15.65C21.09 15.43 21.03 15.15 20.83 15L18.86 13.51C19.07 12.5 19.07 11.47 18.87 10.49H18.86L20.81 9C21.01 8.85 21.07 8.57 20.94 8.35L19.38 5.65C19.25 5.43 18.98 5.34 18.75 5.44L16.48 6.4L16.49 6.39C16.12 6.06 15.7 5.76 15.25 5.5C14.8 5.24 14.34 5.03 13.86 4.87" clipRule="evenodd" fillRule="evenodd" undefined="1"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" d="M13.87 4.89L13.56 2.44C13.53 2.19 13.32 2 13.06 2H9.95C9.7 2 9.48 2.19 9.45 2.44L9.18 4.59C9.16 4.77 9.03 4.93 8.86 4.99C8.02 5.3 7.22 5.78 6.53 6.4L4.25 5.44C4.02 5.34 3.75 5.43 3.62 5.65L2.06 8.35C1.94 8.57 2 8.85 2.2 9L4.17 10.49C3.96 11.5 3.96 12.53 4.16 13.51H4.17L2.2 15C2 15.15 1.94 15.43 2.07 15.65L3.63 18.35C3.76 18.57 4.03 18.66 4.26 18.56L6.54 17.6L6.53 17.61C6.9 17.94 7.32 18.24 7.77 18.5C8.22 18.76 8.68 18.97 9.16 19.13V19.11L9.47 21.56C9.48 21.81 9.7 22 9.95 22H13.07C13.32 22 13.53 21.81 13.57 21.56L13.84 19.41C13.86 19.23 13.99 19.07 14.16 19.01C15 18.7 15.8 18.22 16.49 17.6L18.77 18.56C19 18.66 19.27 18.57 19.4 18.35L20.96 15.65C21.09 15.43 21.03 15.15 20.83 15L18.86 13.51C19.07 12.5 19.07 11.47 18.87 10.49H18.86L20.81 9C21.01 8.85 21.07 8.57 20.94 8.35L19.38 5.65C19.25 5.43 18.98 5.34 18.75 5.44L16.48 6.4L16.49 6.39C16.12 6.06 15.7 5.76 15.25 5.5C14.8 5.24 14.34 5.03 13.86 4.87"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="0" stroke="#1c1a1a" fill="#ffb100" d="M11.51 16C13.7191 16 15.51 14.2091 15.51 12C15.51 9.79086 13.7191 8 11.51 8C9.30086 8 7.51 9.79086 7.51 12C7.51 14.2091 9.30086 16 11.51 16Z" transform="translate(2,2)"></path><path strokeLinejoin="round" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" stroke="#1c1a1a" fill="none" d="M11.51 16C13.7191 16 15.51 14.2091 15.51 12C15.51 9.79086 13.7191 8 11.51 8C9.30086 8 7.51 9.79086 7.51 12C7.51 14.2091 9.30086 16 11.51 16Z"></path>
      </svg>
    }
  ];

  // 
  // ─── STYLE INITIALIZATION ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    wrapper: {
      padding: '20px 20px 20px',
      marginBottom: 40,
      position: 'relative',
      '& .animate-steps .steps-card': {
        opacity: 1,
        transform: 'translateY(0)'
      },
      '@media screen and (min-width:1024px)': {
        marginBottom: 0
      }
    },
    title: {
      writingMode: 'vertical-rl',
      textOrientation: 'upright',
      letterSpacing: -60,
      margin: 'auto',
      fontSize: 130,
      fontWeight: 900,
      color: '#F7F7F7',
      zIndex: -1,
      '@media screen and (min-width:1024px)': {
        writingMode: 'initial',
        letterSpacing: 14,
        fontSize: ' 23.5vw',
        textAlign: 'center'
      },
      '@media screen and (min-width:1450px)': {
        fontSize: 350,
        lineHeight: '530px'
      }
    },
    steps: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '@media screen and (min-width:1024px)': {
        flexDirection: 'row',
        width: '100%',
        maxWidth: '1230px'
      }
    },
    card: {
      width: 210,
      marginTop: 20,
      transform: 'translateY(20px)',
      opacity: 0,
      transition: '0.4s',
      '@media screen and (min-width:1024px)': {
        width: '100%',
        margin: 'auto'
      },
      '&:nth-child(1)': {
        transitionDelay: '0.2s'
      },
      '&:nth-child(2)': {
        transitionDelay: '0.4s'
      },
      '&:nth-child(3)': {
        transitionDelay: '0.6s'
      },
      '&:nth-child(4)': {
        transitionDelay: '0.8s'
      },
      '&:nth-child(5)': {
        transitionDelay: '1s'
      },
      '&:nth-child(6)': {
        transitionDelay: '1.2s'
      }
    },
    icon: {
      width: 60,
      height: 60,
      borderRadius: '100%',
      border: '1px solid var(--primary)',
      margin: 'auto',
      display: 'flex',
      '& svg': {
        margin: 'auto',
        width: 35,
        transform: 'translate(0,-1px)'
      }
    },
    content: {
      fontWeight: 'bold',
      display: 'flex',
      gap: 5,
      justifyContent: 'center'
    },
    number: {
      color: 'var(--primary)',
    }
  })
  const classes = useStyle()

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <div className={classes.wrapper}>
    <h2 className={classes.title}>ÉTAPES</h2>
    <div className={classes.steps} ref={stepsRef} data-animate="animate-steps">
      {steps.map((step) => (
        <div key={step.label} className={classes.card + ' steps-card'}>
          <div className={classes.icon}>{step.icon}</div>
          <div className={classes.content}>
            <span className={classes.label}>{step.label}</span>
            <span className={classes.number}>{step.number}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
};

export default ServiceSteps;